import * as React from "react";
import styled from "react-emotion";
import ScrollNotifier from "../ScrollNotifier";
import { theme, mqMin } from "../../styles/theme";
import { getText } from "../../utilities";

const ArticleHeading = ({ slice }) => {
  return (
    <div
      css={{
        maxWidth: "32rem",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: theme.sans.fontFamily,
        fontWeight: theme.bold,
        "& > h1": {
          fontSize: theme.h1,
          marginTop: theme.space1,
          marginBottom: theme.space1
        }
      }}
      dangerouslySetInnerHTML={{ __html: slice.primary.heading_text.html }}
    />
  );
};

export default ArticleHeading;



// WEBPACK FOOTER //
// ./src/components/ArticleHeading/index.js